export default "__VITE_ASSET__DrTvAiGM__"